export default __webpack_public_path__ + "static/media/gallery_03.f30e4739.jpg";